export const MARKETING_OPT_IN_COPY =
  "I'd like to receive updates via email about our new features and offers.";
